/*
 * @Descripttion: 转移复制车载设备接口
 * @Date: 2026-09-16
 */
import service from '@/utils/request'

// 转移确认（转移预览、模板下载由 c-upload / c-export-file 直连接口）
export const transferConfirm = (params: any) =>
  service.request({
    method: 'post',
    url: '/device/terminal/transferConfirm',
    data: params
  })
